import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5562056d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "result-grid-wrapper",
  id: "grid"
}
const _hoisted_2 = ["title", "onClick"]
const _hoisted_3 = ["title", "onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "no-product-image"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-0 m-0 font-normal" }, "NO IMAGE AVAILABLE", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "tag-container" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "final-price blue-text" }
const _hoisted_12 = { class: "quantity-wrapper" }
const _hoisted_13 = { class: "p-inputgroup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag = _resolveComponent("Tag")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList.slice(this.first, (this.first + this.rows)), (item) => {
        return (_openBlock(), _createBlock(_component_Card, {
          class: "product-item flex flex-column",
          key: item.part_number
        }, {
          header: _withCtx(() => [
            _createElementVNode("span", {
              class: "blue-text product-description",
              title: item.desc,
              onClick: ($event: any) => (_ctx.handleOpenProduct(item))
            }, _toDisplayString(item.desc ? item.desc : "NO DESCRIPTION AVAILABLE"), 9, _hoisted_2),
            _createElementVNode("span", {
              class: "blue-text product-number",
              title: item.part_number,
              onClick: ($event: any) => (_ctx.handleOpenProduct(item))
            }, "Part #" + _toDisplayString(item.altcode1 || item.part_number), 9, _hoisted_3)
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", {
              class: "icon-name-wrapper",
              onClick: ($event: any) => (_ctx.handleOpenProduct(item))
            }, [
              (item.image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "product-image",
                    src: item.image,
                    alt: item.part_number
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Tag, {
                  severity: 
                _ctx.handleOnHandTagColor(
                  item.avail_qty !== undefined ? item.avail_qty : 0
                )
              ,
                  value: 
                _ctx.handleOnHandTagText(
                  item.avail_qty !== undefined ? item.avail_qty : 0
                )
              ,
                  rounded: "",
                  class: "text-center on-hand-tag"
                }, null, 8, ["severity", "value"])
              ])
            ], 8, _hoisted_4),
            _createElementVNode("div", {
              class: "prices-wrapper flex justify-content-evenly align-items-center",
              onClick: ($event: any) => (_ctx.handleOpenProduct(item))
            }, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatPrice(item.price)), 1)
            ], 8, _hoisted_10),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_InputNumber, {
                  class: "quantity-input",
                  modelValue: item.quantity,
                  "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                  inputId: "horizontal-buttons",
                  min: 0,
                  step: _ctx.calculateStep(item),
                  showButtons: "",
                  buttonLayout: "horizontal",
                  decrementButtonclass: "p-button-danger",
                  incrementButtonclass: "p-button-success",
                  incrementButtonIcon: "pi pi-plus",
                  decrementButtonIcon: "pi pi-minus"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "step"]),
                _createVNode(_component_Button, {
                  icon: "pi pi-shopping-cart",
                  class: "cart-btn",
                  onClick: ($event: any) => (_ctx.$emit('addPartToOrder', item))
                }, null, 8, ["onClick"])
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createVNode(_component_Paginator, {
      rows: _ctx.rows,
      totalRecords: _ctx.productList.length,
      template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} Products",
      "onUpdate:rows": _cache[0] || (_cache[0] = ($event: any) => (_ctx.rows=$event)),
      rowsPerPageOptions: this.pageOptions,
      onPage: _ctx.onPage,
      first: _ctx.first,
      "onUpdate:first": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.first) = $event))
    }, null, 8, ["rows", "totalRecords", "rowsPerPageOptions", "onPage", "first"])
  ], 64))
}